import { WithStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import pink from '@material-ui/core/colors/pink';
import yellow from '@material-ui/core/colors/yellow';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Popover from '@material-ui/core/Popover';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
import NotificationsIcon from '@material-ui/icons/Notifications';
import SchoolIcon from '@material-ui/icons/School';

import CloseIcon from '@material-ui/icons/Close';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import RefreshIcon from '@material-ui/icons/Refresh';
import { IMessage } from '../actions/message';
import MessageDialog from '../components/MessageDialog';

import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';

import { openMainMenu } from '../actions/mainMenu';
import { IUserAttr } from '../actions/session';
import Progress from '../components/Progress';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/NavbarScenarioFactory';
import { isMobile } from '../utils/MobileCheck';
import { Routes, Screens } from '../utils/Routes';

import FaUserLargeIcon from 'src/icons/FaUserLarge';
import { UpwardTransition } from 'src/utils';

import { grey } from '@material-ui/core/colors';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '160px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		flex: {
			flex: 1,
		},
		gridWidth: {
			width: '24.2rem',
		},
		image: {
			height: 200,
			width: 200,
		},
		imageContent: {
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'center',
			padding: '5px 5px 5px 5px',
		},
		layout: {
			color: 'black',
			marginBottom: theme.spacing(3),
			marginLeft: theme.spacing(2),
			marginRight: theme.spacing(2),
			marginTop: theme.spacing(3),
			width: 'auto',
			[theme.breakpoints.up(800 + theme.spacing(2) * 2)]: {
				marginLeft: 'auto',
				marginRight: 'auto',
				width: 520,
			},
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		logo: {
			color: '#ddd',
			fontFamily: '"Arial Black", Helvetica-bold',
			fontSize: '20px',
			fontStyle: 'italic',
			fontWeight: 'normal',
			marginRight: 20,
			width: 'auto',
		},
		logoLink: {
			textDecoration: 'none',
		},
		menuButton: {
			marginLeft: -12,
			marginRight: 20,
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileFlex: {
			flex: 1,
			fontSize: '16px',
		},
		mobileImageContent: {
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'center',
			padding: '5px 5px 5px 5px',
			wordBreak: 'break-all',
		},
		mobileTable: {
			minWidth: '100px',
		},
		noneNotice: {
			margin: theme.spacing(2),
		},
		noticeBadge: {
			right: theme.spacing(1.5),
			top: theme.spacing(1.5),
		},
		paper: {
			minWidth: '700px',
		},
		phoneDialog: {
			width: '80%',
		},
		root: {
			flexGrow: 1,
		},
		textFiledClass: {
			color: 'black',
			width: '14.8rem',
		},
		title: {
			flex: 1,
			[theme.breakpoints.down('sm')]: {
				fontSize: '1rem',
			},
		},
		titleLoginIDClass: {
			cursor: 'pointer',
			maxWidth: '16.5em',
			textAlign: 'right',
		},
		titleLoginIDMobileClass: {
			fontSize: '1rem',
			textAlign: 'right',
			width: '7.5em',
		},
		userIconMobile: {
			width: '1.3rem',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IState {
	isShowMenuNotice?: boolean;
	isShowMenuLogout?: boolean;
	isShowConfirmLogout?: boolean;
	isShowUserDetail?: boolean;
	loading: boolean;
	menuNoticeAnchorEl?: HTMLElement;
	menuUserAnchor?: HTMLElement;
	menuLogoutAnchorEl?: HTMLElement;
	openQrCodeDialog: boolean;
	openQrCodeErrorMessageDialog: boolean;
	messages: IMessage[];
}

/**
 * ナビゲーションバー
 */
export class NavbarComponent extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			isShowConfirmLogout: false,
			isShowMenuLogout: false,
			isShowMenuNotice: false,
			isShowUserDetail: false,
			loading: false,
			messages: [],
			openQrCodeDialog: false,
			openQrCodeErrorMessageDialog: false,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.props.fetchShowEmCooperation(this.props.token);
		// #8289: SCORMコンテンツから戻ってきた場合にリクエストキューを全て出力
		if (window.API) {
			window.API.flush();
		}

		if (this.props.setNoticeAt) {
			return;
		}
		this.props.fetchNavbarNotices(this.props.token);
	}

	public render() {
		const { classes, isShowProgress } = this.props;

		return (
			<AppBar position="static">
				<Progress
					open={isShowProgress ? true : false || this.state.loading}
				/>
				<Toolbar>
					<IconButton
						className={classes.menuButton}
						color="inherit"
						aria-label="Menu"
						onClick={this.props.openMainMenu}
					>
						<MenuIcon />
					</IconButton>
					<Link
						to={Routes.getPath(Screens.PERSONAL_PORTAL)}
						className={classes.logoLink}
					>
						<Hidden smDown={true}>
							<Typography variant="h6" className={classes.logo}>
								{i18n.t('Navbar_0001')}
							</Typography>
						</Hidden>
					</Link>
					<Typography
						variant="h6"
						color="inherit"
						noWrap={true}
						className={classes.title}
					>
						{this.props.title}
					</Typography>

					<this.UserDetail />
					{this.props.isShowEmCooperation && <this.QrCodeIcon />}
					<this.NoticeIcon />
					<this.LogoutIcon />
				</Toolbar>
			</AppBar>
		);
	}

	/**
	 * スマホで利用メニュー
	 */
	protected QrCodeIcon: React.FC<{}> = props => {
		return (
			<>
				<IconButton
					onClick={this.handleShowQrCodeDialog}
					color="inherit"
					aria-owns="phone"
					aria-haspopup="true"
				>
					<PhoneIphoneIcon />
				</IconButton>

				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openQrCodeDialog}
					onClose={this.handlecloseQrCodeDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.phoneDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar
							style={{
								justifyContent: 'flex-end',
							}}
						>
							<IconButton
								onClick={this.handleShowQrCodeDialog}
								color="inherit"
								aria-label="Refresh"
							>
								<RefreshIcon />
							</IconButton>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseQrCodeDialog}
							>
								<CloseIcon />
							</IconButton>
						</Toolbar>
					</AppBar>
					<div className={this.props.classes.root}>
						{isMobile() && (
							<>
								<div className={this.props.classes.wrapDiv}>
									<div
										className={
											this.props.classes.imageContent
										}
									>
										<Typography component="p">
											<img
												className={
													this.props.classes.image
												}
												src={this.props.qrCodeBase64}
											/>
										</Typography>
									</div>
									<div
										className={
											this.props.classes
												.mobileImageContent
										}
									>
										<a
											href={this.props.emRegistrationUrl}
											target="_blank"
											className={this.props.classes.link}
										>
											{this.props.emRegistrationUrl}
										</a>
									</div>
									<Paper style={{ overflowX: 'auto' }}>
										<div
											className={
												this.props.classes.mobileTable
											}
										>
											<div
												className={
													this.props.classes
														.mobileCellItemName
												}
											>
												{i18n.t('QrCode_0001')}
											</div>
											<div
												className={
													this.props.classes
														.mobileCellItemValue
												}
											>
												{
													this.props
														.registrationExpirationDate
												}
											</div>
											<div
												className={
													this.props.classes
														.mobileCellItemName
												}
											>
												{i18n.t('QrCode_0002')}
											</div>
											<div
												className={
													this.props.classes
														.mobileCellItemValue
												}
											>
												{this.props.emTenantId}
											</div>
											<div
												className={
													this.props.classes
														.mobileCellItemName
												}
											>
												{i18n.t('QrCode_0003')}
											</div>
											<div
												className={
													this.props.classes
														.mobileCellItemValue
												}
											>
												{this.props.companyCode}
											</div>
											{this.props.userId != null &&
												this.props.userId !== '' && (
													<>
														<div
															className={
																this.props
																	.classes
																	.mobileCellItemName
															}
														>
															{i18n.t(
																'QrCode_0004'
															)}
														</div>
														<div
															className={
																this.props
																	.classes
																	.mobileCellItemValue
															}
														>
															{this.props.userId}
														</div>
													</>
												)}
											{this.props.signinUrl != null &&
												this.props.signinUrl !== '' && (
													<>
														<div
															className={
																this.props
																	.classes
																	.mobileCellItemName
															}
														>
															{i18n.t(
																'QrCode_0005'
															)}
														</div>
														<div
															className={
																this.props
																	.classes
																	.mobileCellItemValue
															}
														>
															<a
																href={
																	this.props
																		.signinUrl
																}
																target="_blank"
																className={
																	this.props
																		.classes
																		.link
																}
															>
																{
																	this.props
																		.signinUrl
																}
															</a>
														</div>
													</>
												)}
										</div>
									</Paper>
								</div>
							</>
						)}
						{!isMobile() && (
							<>
								<div className={this.props.classes.wrapDiv}>
									<div
										className={
											this.props.classes.imageContent
										}
									>
										<Typography component="p">
											<img
												className={
													this.props.classes.image
												}
												src={this.props.qrCodeBase64}
											/>
										</Typography>
									</div>
									<div
										className={
											this.props.classes.imageContent
										}
									>
										<a
											href={this.props.emRegistrationUrl}
											target="_blank"
											className={this.props.classes.link}
										>
											{this.props.emRegistrationUrl}
										</a>
									</div>
									<Paper className={this.props.classes.paper}>
										<Table>
											<TableBody>
												<TableRow>
													<TableCell
														className={
															this.props.classes
																.cellItemName
														}
													>
														{i18n.t('QrCode_0001')}
													</TableCell>
													<TableCell
														className={
															this.props.classes
																.cellItemValue
														}
													>
														{
															this.props
																.registrationExpirationDate
														}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell
														className={
															this.props.classes
																.cellItemName
														}
													>
														{i18n.t('QrCode_0002')}
													</TableCell>
													<TableCell
														className={
															this.props.classes
																.cellItemValue
														}
													>
														{this.props.emTenantId}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell
														className={
															this.props.classes
																.cellItemName
														}
													>
														{i18n.t('QrCode_0003')}
													</TableCell>
													<TableCell
														className={
															this.props.classes
																.cellItemValue
														}
													>
														{this.props.companyCode}
													</TableCell>
												</TableRow>
												{this.props.userId != null &&
													this.props.userId !==
														null && (
														<>
															<TableRow>
																<TableCell
																	className={
																		this
																			.props
																			.classes
																			.cellItemName
																	}
																>
																	{i18n.t(
																		'QrCode_0004'
																	)}
																</TableCell>
																<TableCell
																	className={
																		this
																			.props
																			.classes
																			.cellItemValue
																	}
																>
																	{
																		this
																			.props
																			.userId
																	}
																</TableCell>
															</TableRow>
														</>
													)}
												{this.props.signinUrl != null &&
													this.props.signinUrl !==
														null && (
														<>
															<TableRow>
																<TableCell
																	className={
																		this
																			.props
																			.classes
																			.cellItemName
																	}
																>
																	{i18n.t(
																		'QrCode_0005'
																	)}
																</TableCell>
																<TableCell
																	className={
																		this
																			.props
																			.classes
																			.cellItemValue
																	}
																>
																	<a
																		href={
																			this
																				.props
																				.signinUrl
																		}
																		target="_blank"
																		className={
																			this
																				.props
																				.classes
																				.link
																		}
																	>
																		{
																			this
																				.props
																				.signinUrl
																		}
																	</a>
																</TableCell>
															</TableRow>
														</>
													)}
											</TableBody>
										</Table>
									</Paper>
								</div>
							</>
						)}
					</div>
				</Dialog>
				<MessageDialog
					open={this.state.openQrCodeErrorMessageDialog}
					showCancelButton={false}
					title={i18n.t('QrCode_0006')}
					contents={this.state.messages}
					onClose={this.errorMessageQrCodeDialogClose}
					onClickOk={this.errorMessageQrCodeDialogClose}
				/>
			</>
		);
	};

	/**
	 * 通知ボタン&バッジ&メニュー
	 */
	protected NoticeIcon: React.FC<{}> = props => {
		const { classes } = this.props;

		const waitingStudentApprovalCnt =
			this.props.waitingStudentApprovalCnt || 0;
		const waitingStudentCancelCnt = this.props.waitingStudentCancelCnt || 0;
		const waitingPerformanceApprovalCnt =
			this.props.waitingPerformanceApprovalCnt || 0;
		const applyingStudentApplyCurriculumCnt =
			this.props.applyingStudentApplyCurriculumCnt || 0;
		const applyingStudentApplyTrainingCnt =
			this.props.applyingStudentApplyTrainingCnt || 0;
		const applyingCancelApplyCurriculumCnt =
			this.props.applyingCancelApplyCurriculumCnt || 0;
		const applyingCancelApplyTrainingCnt =
			this.props.applyingCancelApplyTrainingCnt || 0;
		const applyingPerformanceApplyTrainingCnt =
			this.props.applyingPerformanceApplyTrainingCnt || 0;
		const notices = [] as INoticeListItemProps[];

		if (waitingStudentApprovalCnt > 0) {
			notices.push({
				link: this.handleCloseMenuNotice,
				text: i18n.t('Navbar_0002', { waitingStudentApprovalCnt }),
				title: i18n.t('Navbar_0003'),
				type: NoticeType.NOTICE_WAITING,
			});
		}
		if (waitingStudentCancelCnt > 0) {
			notices.push({
				link: this.handleCloseMenuNotice,
				text: i18n.t('Navbar_0004', { waitingStudentCancelCnt }),
				title: i18n.t('Navbar_0005'),
				type: NoticeType.NOTICE_WAITING,
			});
		}
		if (waitingPerformanceApprovalCnt > 0) {
			notices.push({
				link: this.handleCloseMenuNotice,
				text: i18n.t('Navbar_0006', { waitingPerformanceApprovalCnt }),
				title: i18n.t('Navbar_0007'),
				type: NoticeType.NOTICE_WAITING,
			});
		}
		if (applyingStudentApplyCurriculumCnt > 0) {
			notices.push({
				link: this.handleNoticeLinkApplying,
				text: i18n.t('Navbar_0008', {
					applyingStudentApplyCurriculumCnt,
				}),
				title: i18n.t('Navbar_0009'),
				type: NoticeType.NOTICE_APPLYING,
			});
		}
		if (applyingStudentApplyTrainingCnt > 0) {
			notices.push({
				link: this.handleNoticeLinkApplying,
				text: i18n.t('Navbar_0010', {
					applyingStudentApplyTrainingCnt,
				}),
				title: i18n.t('Navbar_0011'),
				type: NoticeType.NOTICE_APPLYING,
			});
		}
		if (applyingCancelApplyCurriculumCnt > 0) {
			notices.push({
				link: this.handleNoticeLinkApplying,
				text: i18n.t('Navbar_0012', {
					applyingCancelApplyCurriculumCnt,
				}),
				title: i18n.t('Navbar_0013'),
				type: NoticeType.NOTICE_APPLYING,
			});
		}
		if (applyingCancelApplyTrainingCnt > 0) {
			notices.push({
				link: this.handleNoticeLinkApplying,
				text: i18n.t('Navbar_0014', { applyingCancelApplyTrainingCnt }),
				title: i18n.t('Navbar_0015'),
				type: NoticeType.NOTICE_APPLYING,
			});
		}
		if (applyingPerformanceApplyTrainingCnt > 0) {
			notices.push({
				link: this.handleNoticeLinkApplying,
				text: i18n.t('Navbar_0016', {
					applyingPerformanceApplyTrainingCnt,
				}),
				title: i18n.t('Navbar_0017'),
				type: NoticeType.NOTICE_APPLYING,
			});
		}

		if (notices.length === 0) {
			return (
				<>
					<IconButton
						onClick={this.handleButtonNotice}
						aria-label="Notifications"
						color="inherit"
					>
						<NotificationsIcon />
					</IconButton>
					<Popover
						id="notice-menu"
						anchorEl={this.state.menuNoticeAnchorEl}
						open={this.state.isShowMenuNotice ? true : false}
						onClose={this.handleCloseMenuNotice}
						anchorOrigin={{
							horizontal: 'center',
							vertical: 'bottom',
						}}
						transformOrigin={{
							horizontal: 'center',
							vertical: 'top',
						}}
						getContentAnchorEl={undefined}
					>
						<Typography className={classes.noneNotice}>
							{i18n.t('Navbar_0018')}
						</Typography>
					</Popover>
				</>
			);
		}

		return (
			<>
				<Badge
					badgeContent={notices.length}
					color="secondary"
					classes={{ badge: classes.noticeBadge }}
				>
					<IconButton
						onClick={this.handleButtonNotice}
						aria-label="Notifications"
						color="inherit"
					>
						<NotificationsIcon />
					</IconButton>
				</Badge>
				<Popover
					id="notice-menu"
					anchorEl={this.state.menuNoticeAnchorEl}
					open={this.state.isShowMenuNotice ? true : false}
					onClose={this.handleCloseMenuNotice}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
					getContentAnchorEl={undefined}
				>
					<List component="nav">
						{notices.map((notice, i) => {
							return <NoticeListItem key={i} {...notice} />;
						})}
					</List>
				</Popover>
			</>
		);
	};

	/**
	 * ログアウトボタン&メニュー&ダイアログ
	 */
	protected LogoutIcon: React.FC<{}> = props => {
		return (
			<>
				<IconButton
					onClick={this.handleButtonLogout}
					color="inherit"
					aria-owns="logout-menu"
					aria-haspopup="true"
				>
					<ExitToAppIcon />
				</IconButton>
				<Menu
					id="logout-menu"
					anchorEl={this.state.menuLogoutAnchorEl}
					open={this.state.isShowMenuLogout ? true : false}
					onClose={this.handleCloseMenuLogout}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
					getContentAnchorEl={undefined}
				>
					<MenuItem onClick={this.handleMenuLogout}>
						{i18n.t('Navbar_0019')}
					</MenuItem>
				</Menu>
				<Dialog
					open={this.state.isShowConfirmLogout ? true : false}
					TransitionComponent={UpwardTransition}
					keepMounted={true}
					onClose={this.handleCloseConfirmLogout}
					aria-labelledby="alert-dialog-slide-title"
					aria-describedby="alert-dialog-slide-description"
				>
					<DialogTitle id="alert-dialog-slide-title">
						{i18n.t('Navbar_0020')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('Navbar_0021')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleLogout} color="primary">
							{i18n.t('Navbar_0022')}
						</Button>
						<Button onClick={this.handleCloseConfirmLogout}>
							{i18n.t('Navbar_0023')}
						</Button>
					</DialogActions>
				</Dialog>
			</>
		);
	};

	/**
	 * ユーザ情報ポップアップ
	 */
	protected UserDetail: React.FC<{}> = props => {
		const { classes, loginID, userAttr } = this.props;
		const userDetailStyles = {
			popover: {
				paddingLeft: '0.5%',
				top: '5%',
			},
			popoverMobile: {
				left: '5px',
				paddingLeft: '0.5%',
				top: '5%',
			},
			textLabel: {
				color: 'black',
			},
		};
		return (
			<>
				{!isMobile() && (
					<Typography
						variant="h6"
						color="inherit"
						noWrap={true}
						className={
							isMobile()
								? classes.titleLoginIDMobileClass
								: classes.titleLoginIDClass
						}
						onClick={this.handleButtonUserDetail}
					>
						{loginID}
					</Typography>
				)}
				{isMobile() && <this.UserIcon />}
				<Popover
					id="userdetail-menu"
					anchorEl={this.state.menuUserAnchor}
					open={this.state.isShowUserDetail ? true : false}
					onClose={this.handleCloseMenuUserDetail}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
					getContentAnchorEl={undefined}
					PaperProps={{
						style: isMobile()
							? userDetailStyles.popoverMobile
							: userDetailStyles.popover,
					}}
				>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="loginId"
									label={i18n.t('ProfileForm_0003')}
									value={loginID}
									margin="normal"
									disabled={true}
									InputProps={{
										classes: {
											disabled: classes.textFiledClass,
										},
									}}
									InputLabelProps={{
										style: userDetailStyles.textLabel,
									}}
								/>
							</Grid>
						</Grid>
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="familyNameJa"
									label={i18n.t('ProfileForm_0007')}
									value={userAttr.userFamilyName}
									disabled={true}
									InputProps={{
										classes: {
											disabled: classes.textFiledClass,
										},
									}}
									InputLabelProps={{
										style: userDetailStyles.textLabel,
									}}
								/>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="firstNameJa"
									label={i18n.t('ProfileForm_0008')}
									value={userAttr.userName}
									disabled={true}
									InputProps={{
										classes: {
											disabled: classes.textFiledClass,
										},
									}}
									InputLabelProps={{
										style: userDetailStyles.textLabel,
									}}
								/>
							</Grid>
						</Grid>
					</div>
				</Popover>
			</>
		);
	};

	/**
	 * ユーザアイコン
	 */
	protected UserIcon: React.FC<{}> = props => {
		const { classes } = this.props;
		return (
			<IconButton
				onClick={this.handleButtonUserDetail}
				aria-label="Notifications"
				color="inherit"
			>
				<FaUserLargeIcon className={classes.userIconMobile} />
			</IconButton>
		);
	};

	/**
	 * 通知メニュークローズハンドラ
	 */
	protected handleCloseMenuNotice = () => {
		this.setState({
			isShowMenuNotice: false,
		});
	};

	/**
	 * ユーザ情報ポップアップクローズハンドラ
	 */
	protected handleCloseMenuUserDetail = () => {
		this.setState({
			isShowUserDetail: false,
		});
	};

	/**
	 * 承認リンクハンドラ
	 */
	protected handleNoticeLinkApplying = () => {
		this.handleCloseMenuNotice();
		this.props.pushHistory(Screens.PERSONAL_STATUS);
	};

	/**
	 * 通知ボタンハンドラ
	 */
	protected handleButtonNotice = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			isShowMenuNotice: true,
			menuNoticeAnchorEl: event.currentTarget,
		});
	};

	/**
	 * ユーザ情報ポップアップハンドラ
	 */
	protected handleButtonUserDetail = (
		event: React.MouseEvent<HTMLElement>
	) => {
		this.setState({
			isShowUserDetail: true,
			menuUserAnchor: event.currentTarget,
		});
	};

	/**
	 * スマホで利用ダイアログオープン
	 */
	protected handleShowQrCodeDialog = async (
		event: React.MouseEvent<HTMLElement>
	) => {
		this.setState({
			loading: true,
		});
		this.props
			.createFetchShowEmQrCode(this.props.token)
			.then(data => {
				if (this.props.resultFlg) {
					this.setState({
						loading: false,
						openQrCodeDialog: true,
					});
				} else {
					const convertToIMessages = (): IMessage[] => {
						if (this.props.errorMessageList) {
							return this.props.errorMessageList.map(
								errorMessage => ({
									content: 'LMCM_E_16212',
									replacements: [errorMessage],
								})
							);
						} else {
							return [];
						}
					};
					this.setState({
						loading: false,
						messages: convertToIMessages(),
						openQrCodeDialog: false,
						openQrCodeErrorMessageDialog: true,
					});
				}
			})
			.catch(e => {
				this.setState({
					loading: false,
					openQrCodeDialog: false,
				});
				return;
			});
	};

	/**
	 * スマホで利用ダイアログクローズ
	 */
	protected handlecloseQrCodeDialog = () => {
		this.setState({
			openQrCodeDialog: false,
		});
	};

	/**
	 * スマホで利用エラーメッセージクローズ
	 */
	protected errorMessageQrCodeDialogClose = () => {
		this.setState({ openQrCodeErrorMessageDialog: false });
	};

	/**
	 * ログアウトボタンハンドラ
	 */
	protected handleButtonLogout = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			isShowMenuLogout: true,
			menuLogoutAnchorEl: event.currentTarget,
		});
	};

	/**
	 * ログアウトメニュークローズハンドラ
	 */
	protected handleCloseMenuLogout = () => {
		this.setState({
			isShowMenuLogout: false,
		});
	};

	/**
	 * ログアウトメニューハンドラ
	 */
	protected handleMenuLogout = () => {
		this.setState({
			isShowConfirmLogout: true,
			isShowMenuLogout: false,
		});
	};

	/**
	 * ログアウト確認クローズハンドラ
	 */
	protected handleCloseConfirmLogout = () => {
		this.setState({
			isShowConfirmLogout: false,
		});
	};

	/**
	 * ログアウトハンドラ
	 */
	protected handleLogout = () => {
		this.props.logout(
			this.props.token,
			this.props.tsqWindow,
			this.props.userAttr
		);
	};
}

// 通知のメニュー項目
enum NoticeType {
	NOTICE_WAITING,
	NOTICE_APPLYING,
}
interface INoticeListItemProps {
	link: () => void;
	text: string;
	title: string;
	type: NoticeType;
}
const NoticeListItem: React.FC<INoticeListItemProps> = props => {
	return (
		<>
			{props.type === NoticeType.NOTICE_WAITING && (
				<ListItem
					button={false}
					onClick={props.link}
					style={{ cursor: 'default' }}
				>
					<Avatar
						style={{
							backgroundColor: pink[200],
							color: '#fff',
							cursor: 'default',
						}}
					>
						<MoveToInboxIcon />
					</Avatar>
					<ListItemText
						primary={props.title}
						secondary={props.text}
						style={{
							cursor: 'default',
						}}
					/>
				</ListItem>
			)}
			{props.type === NoticeType.NOTICE_APPLYING && (
				<ListItem
					button={true}
					onClick={props.link}
					style={{ cursor: 'pointer' }}
				>
					<Avatar
						style={{
							backgroundColor: yellow[700],
							color: '#fff',
							cursor: 'pointer',
						}}
					>
						<SchoolIcon />
					</Avatar>
					<ListItemText
						primary={props.title}
						secondary={props.text}
						style={{
							cursor: 'pointer',
						}}
					/>
				</ListItem>
			)}
			{props.type !== NoticeType.NOTICE_APPLYING &&
				props.type !== NoticeType.NOTICE_WAITING && (
					<ListItem button={true} onClick={props.link}>
						<Avatar
							style={{
								backgroundColor: yellow[700],
								color: '#fff',
							}}
						>
							<SchoolIcon />
						</Avatar>
						<ListItemText
							primary={props.title}
							secondary={props.text}
						/>
					</ListItem>
				)}
		</>
	);
};

export const mapStateToProps = (state: IRootState) => ({
	...state.navbar,
	companyCode: state.navbar.companyCode,
	emRegistrationUrl: state.navbar.emRegistrationUrl,
	emTenantId: state.navbar.emTenantId,
	errorMessageList: state.navbar.errorMessageList,
	isShowEmCooperation: state.navbar.isShowEmCooperation,
	isShowProgress: state.navbar.isShowProgress,
	loginID: state.session.loginID,
	qrCodeBase64: state.navbar.qrCodeBase64,
	registrationExpirationDate: state.navbar.registrationExpirationDate,
	resultFlg: state.navbar.resultFlg,
	signinUrl: state.navbar.signinUrl,
	token: state.session.token,
	tsqWindow: state.mainMenu.tsqWindow,
	userAttr: state.session.userAttr,
	userId: state.navbar.userId,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
	createFetchShowEmQrCode: (token: string) => {
		const s = ScenarioFactory.createFetchShowEmQrCode(dispatch, token);
		return s.run({});
	},
	fetchNavbarNotices: (token: string) => {
		const s = ScenarioFactory.createFetchNavbarNotices(dispatch, token);
		s.run({});
	},
	fetchShowEmCooperation: (token: string) => {
		const s = ScenarioFactory.createFetchEmCooperation(dispatch, token);
		return s.run({});
	},
	logout: (token: string, tsqWindow: Window | null, userAttr: IUserAttr) => {
		const s = ScenarioFactory.createLogout(
			dispatch,
			token,
			userAttr.loginType
		);
		s.run({ tsqWindow });
	},
	openMainMenu: () => dispatch(openMainMenu({ isOpen: true })),
	pushHistory: (screen: Screens) => dispatch(push(Routes.getPath(screen))),
});

export interface INavbarProps {
	title: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & INavbarProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(NavbarComponent);

const Navbar = withStyles(styles)(Connected);
Navbar.displayName = 'Navbar';

export default Navbar;



// WEBPACK FOOTER //
// ./src/containers/Navbar.tsx